import { CurrentStoreType } from '@/components/content/Header/parts/LocateStore';
import { StoreLocatorStatus } from '@/components/content/StoreLocator/components/StoreLocatorList/StoreLocatorStatus';
import {
	storeLocatorHeaderInfoStoreNameSX,
	storeLocatorHeaderInfoStoreSX,
	storeLocatorHeaderInfoSX,
	storeLocatorInfoIconSX,
} from '@/components/content/StoreLocator/styles/StoreLocatorHeaderInfo/storeLocatorHeaderInfoStyles';
import stateCitiesData from '@/data/Content/StoreLocator/storeLocatorStateCitiesList.json';
import { logEventWithValues } from '@/data/utils/logEventsUtils';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FilledStoreIcon } from 'presentation/svgImages/FilledStoreIcon';
import { StoreIcon } from 'presentation/svgImages/StoreIcon';
import { FC, useEffect, useMemo } from 'react';

export const StoreLocatorHeaderInfo: FC<{
	isLocatorOptionSelected: boolean;
	currentStoreValues: CurrentStoreType;
	isSettingLocatorDefault: boolean;
}> = ({ isLocatorOptionSelected, currentStoreValues, isSettingLocatorDefault }) => {
	const theme = useTheme();
	const cityList = stateCitiesData.formScheduleObject;
	const storeSelected = useMemo(() => {
		const state = cityList.find((stores) => stores.stateId === currentStoreValues?.stateId);
		const store = state?.stores.find(
			(storeData) => storeData.stLocId === currentStoreValues?.stLocId
		);
		return store ? { ...store, stateId: state?.stateId } : undefined;
	}, [cityList, currentStoreValues]);
	const Icon = isLocatorOptionSelected ? FilledStoreIcon : StoreIcon;

	useEffect(() => {
		if (storeSelected) {
			logEventWithValues('set_store', storeSelected);
		}
	}, [storeSelected]);

	return (
		<Box
			sx={storeLocatorHeaderInfoSX(theme, isLocatorOptionSelected)}
			id="storeSelectorPanelTrigger"
		>
			{!!storeSelected ? <StoreLocatorStatus storeData={storeSelected} /> : null}
			<Box id="storeInfo" sx={storeLocatorHeaderInfoStoreSX}>
				<Icon sx={storeLocatorInfoIconSX(isLocatorOptionSelected)} />
				{!isSettingLocatorDefault && storeSelected ? (
					<Box>
						<Typography
							variant="body1"
							sx={storeLocatorHeaderInfoStoreNameSX}
						>{`${storeSelected?.storeName}, ${storeSelected?.shortName}`}</Typography>
					</Box>
				) : null}
			</Box>
		</Box>
	);
};
